/* istanbul ignore file */
export enum FieldTypePrimitive {
    String = 'string',
    Boolean = 'boolean',
    Number = 'number',
}
